const minMobileWidth = 767;

export const checkMobileMode = (): boolean =>  { 
    return window.innerWidth < minMobileWidth;
  }